import AllRoutes from './AllRoutes/AllRoutes';
import './App.css';
import FilterSection from './Components/Filtersection/FilterSection';
import Footer from './Components/Footer/Footer';
import HomePage from './Components/HomePage/HomePage';
import ProjectHead from './Components/modal/ProjectHead';
import Navbar from './Components/Navbar/Navbar';
import Signup from './Components/SignupPage/Signup';
import TableContainethings from './Components/Table/TableContainethings';

import Time_Tracker from './Components/Time_Tracker/Time_Tracker';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
